<div class="link">
  <i [class]='iconClass'></i>
  <app-autocomplete [formControl]="choixControl" reactiveElement
    [undeletableIds]="undeletableIds"
    [multiselect]="true"
    [url]="gestionProjetService.getUrlLiensPossibles(typeLien)"
    idField="IdLien"
    libelleField="Libelle"
    searchField="Libelle"
    [sortedBy]="['Libelle']"
    (selected)="updateSelection()"></app-autocomplete>
</div>
